import Vue from 'vue';
import Component from 'vue-class-component';
import { debounce } from 'lodash-es';

@Component({
  methods: {
    updatePrice: debounce(async function (price, priceType, priceValue, event) {
      const newPrice = {
        ...price,
      };
      const newUpcomingPrices = [...this.localContentOwnership.upcomingPrices];

      const priceIndex = newUpcomingPrices.findIndex(
        upcomingPrice => upcomingPrice.country === newPrice.country
      );

      newPrice.id = null; // We set id to null for a price that has changed, The mutation that creates prices only creates ones without id's.

      if (priceValue && priceValue >= 0) {
        newPrice[priceType] = Math.floor(parseFloat(priceValue) * 100);

        // TODO: RE-ENABLE REGIONAL PRICING
        // remove the check for USA when regional pricing goes out. but keep override
        if (newPrice.country !== 'USA') {
          newPrice[`${priceType}Override`] = true;
          // Remove this else if part for regional pricing enable
        } else if (priceType === 'priceMinute') {
          this.$emit(
            'edit:contentOwnership',
            'basePriceMinute',
            Math.floor(priceValue * 100)
          );
          await this.$nextTick();
        }
      } else {
        newPrice[`${priceType}Override`] = false;

        let tempPrice;
        if (this.localContentOwnership.regionalPricing) {
          tempPrice = this.updatePriceWithRegionalAdjustment(newPrice);
        } else {
          tempPrice = this.updatePriceWithoutRegionalAdjustment(newPrice);
        }

        setTimeout(() => {
          event.target.value = tempPrice[priceType] / 100;
        }, 0);
        newPrice[priceType] = tempPrice[priceType];
      }

      if (~priceIndex) {
        newUpcomingPrices[priceIndex] = newPrice;
      } else {
        newUpcomingPrices.push(newPrice);
      }

      // TODO: RE-ENABLE REGIONAL PRICING
      // Waiting for regional pricing to be enabled to enable this for every country
      // if (newPrice._distributeLock) {
      //   this.updateFlash(false);
      // }

      this.updateContentOwnershipUpcomingPrices(newUpcomingPrices);
    }, 500),
  },
})
export default class RegionalPricingUpdatePriceMixin extends Vue {
  // TODO: RE-ENABLE REGIONAL PRICING
  updateUSA () {}

  async updatePrices (notify = true) {
    let newUpcomingPrices;

    if (this.localContentOwnership.regionalPricing) {
      newUpcomingPrices = this.prices.map(price => {
        return this.updatePriceWithRegionalAdjustment(price);
      });
    } else {
      newUpcomingPrices = this.prices.map(price => {
        return this.updatePriceWithoutRegionalAdjustment(price);
      });
    }

    this.updateContentOwnershipUpcomingPrices(newUpcomingPrices);

    if (notify) this.updateFlash(true);
  }

  updatePriceWithRegionalAdjustment (price) {
    const newPrice = {
      ...price,
    };
    const effectiveParityRate = this.getCountryFromcountryCode(price.country)
      .effectiveParityRate;

    if (
      this.localContentOwnership.basePriceMinute !== null &&
      !price.priceMinuteOverride
    ) {
      newPrice.priceMinute = Math.round(
        this.localContentOwnership.basePriceMinute * effectiveParityRate
      );
    }

    if (
      this.localContentOwnership.basePriceMonth !== null &&
      !price.priceMonthOverride
    ) {
      newPrice.priceMonth = Math.round(
        this.localContentOwnership.basePriceMonth * effectiveParityRate
      );
    } else if (this.localContentOwnership.basePriceMonth === null) {
      newPrice.priceMonth = null;
    }

    if (
      this.localContentOwnership.basePriceYear !== null &&
      !price.priceYearOverride
    ) {
      newPrice.priceYear = Math.round(
        this.localContentOwnership.basePriceYear * effectiveParityRate
      );
    } else if (this.localContentOwnership.basePriceYear === null) {
      newPrice.priceYear = null;
    }

    if (
      this.localContentOwnership.basePricePlay !== null &&
      !price.pricePlayOverride
    ) {
      newPrice.pricePlay = Math.round(
        this.localContentOwnership.basePricePlay * effectiveParityRate
      );
    } else if (this.localContentOwnership.basePricePlay === null) {
      newPrice.pricePlay = null;
    }

    newPrice.id = null;
    return newPrice;
  }

  updatePriceWithoutRegionalAdjustment (price) {
    const newPrice = {
      ...price,
    };

    if (!price.priceMinuteOverride) { newPrice.priceMinute = this.localContentOwnership.basePriceMinute; }

    if (!price.priceMonthOverride) {
      newPrice.priceMonth = this.localContentOwnership.basePriceMonth;
    } else if (this.localContentOwnership.basePriceMonth === null) {
      newPrice.priceMonth = null;
    }

    if (!price.priceYearOverride) {
      newPrice.priceYear = this.localContentOwnership.basePriceYear;
    } else if (this.localContentOwnership.basePriceYear === null) {
      newPrice.priceYear = null;
    }

    if (!price.pricePlayOverride) {
      newPrice.pricePlay = this.localContentOwnership.basePricePlay;
    } else if (this.localContentOwnership.basePricePlay === null) {
      newPrice.pricePlay = null;
    }

    newPrice.id = null;
    return newPrice;
  }

  updateDistribute (price) {
    const newPrice = {
      ...price,
    };
    const newUpcomingPrices = [...this.localContentOwnership.upcomingPrices];

    const priceIndex = newUpcomingPrices.findIndex(
      upcomingPrice => upcomingPrice.country === newPrice.country
    );

    newPrice.distribute = !newPrice.distribute;
    newPrice.id = null;

    if (~priceIndex) {
      newUpcomingPrices[priceIndex] = newPrice;
    } else {
      newUpcomingPrices.push(newPrice);
    }

    this.updateContentOwnershipUpcomingPrices(newUpcomingPrices);
  }

  updateAllDistribute (distribute) {
    const newUpcomingPrices = this.prices.map(price => {
      const newPrice = { ...price };
      newPrice.distribute = distribute;
      newPrice.id = null;
      return newPrice;
    });

    this.updateContentOwnershipUpcomingPrices(newUpcomingPrices);
  }
}
